import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import './MegaTest.css';

const Intro = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="test-intro">
            <div className="intro-card fade-in">
                <div className="badge">{t('mega_test.intro.badge')}</div>
                <h1 className="title">{t('mega_test.intro.title')}</h1>
                <p className="description">
                    <Trans i18nKey="mega_test.intro.desc" />
                </p>

                <div className="features">
                    <div className="feature-item">
                        <span className="icon">📈</span>
                        <div className="text">
                            <h4>{t('mega_test.intro.feature_seb_title')}</h4>
                            <p>{t('mega_test.result.tabs.seb')}</p>
                        </div>
                    </div>
                    <div className="feature-item">
                        <span className="icon">🧠</span>
                        <div className="text">
                            <h4>{t('mega_test.intro.feature_beh_title')}</h4>
                            <p>{t('mega_test.result.tabs.behavior')}</p>
                        </div>
                    </div>
                </div>

                <div className="info-box">
                    <p>{t('mega_test.intro.eta')}</p>
                    <p>{t('mega_test.intro.tip')}</p>
                </div>

                <button className="start-btn" onClick={() => navigate('/mega-test/q/1')}>
                    {t('mega_test.intro.start')}
                </button>
            </div>


        </div>
    );
};

export default Intro;
